// extracted by mini-css-extract-plugin
export default {"brandPromo":"oG-z","carousel":"pG-z"};